import { Buffer } from 'buffer';

export default (type, id) => Buffer.from(`${type}:${id}`).toString('base64');
